import React from 'react'
import { Modal } from 'antd';
import { useQuizFormContext } from '../../hooks/quiz-form-context';
import "./CongratulationsModel.css"
import HandbookCompletionDescription from '../handbook-completion-description/handbook-completion-description';

const CongratulationsModel = ({ description }) => {
  const { isCongratulationsModalOpen, setIsCongratulationsModalOpen } = useQuizFormContext()

  const handleCancel = () => {
    setIsCongratulationsModalOpen(false);
  };
  return (
    <div>
      <Modal
        open={isCongratulationsModalOpen}
        footer={null}
        onCancel={handleCancel}
        centered={true}
      >
        <div className="congratulations-model-container">
          <HandbookCompletionDescription description={description} isPopup />
        </div>
      </Modal>
    </div>
  )
}

export default CongratulationsModel